/**
 * Données du tableau comparatif (repli si la clé i18n pricing.comparison
 * manque). Trois plans ; l'IA est la même partout, vendue à part.
 */

import type { SubscriptionPlan } from '@/api/subscription'

export const COMPARISON_PLAN_ORDER: ReadonlyArray<SubscriptionPlan> = ['solo', 'team', 'business']

export interface ComparisonCategory {
  name: string
  icon?: string
  rows: ReadonlyArray<readonly string[]>
}

/**
 * Format : ['Ligne', solo, team, business]
 * Valeurs spéciales : '✓' (rond bleu), '✗' (—), autre = texte brut.
 */
export const COMPARISON_CATEGORIES_FR: ReadonlyArray<ComparisonCategory> = [
  {
    "name": "FONCTIONS DE BASE",
    "icon": "phone",
    "rows": [
      [
        "Appels CA/US",
        "Illimités",
        "Illimités",
        "Illimités"
      ],
      [
        "Textos",
        "Illimités",
        "Illimités",
        "Illimités"
      ],
      [
        "Numéro local inclus",
        "1 / utilisateur",
        "1 / utilisateur",
        "1 / utilisateur"
      ],
      [
        "Numéro en plus",
        "5 $ / mois",
        "5 $ / mois",
        "5 $ / mois"
      ],
      [
        "Numéro sans frais",
        "12 $ / mois",
        "12 $ / mois",
        "12 $ / mois"
      ],
      [
        "Portage de votre numéro",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Transfert d'appel",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Messagerie vocale transcrite",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Heures d'ouverture de l'entreprise",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Horaires par utilisateur",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Numéros partagés et groupes",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Enregistrement des appels",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Transcriptions et résumés IA",
        "✓",
        "✓",
        "✓"
      ]
    ]
  },
  {
    "name": "AGENT IA",
    "icon": "sparkle",
    "rows": [
      [
        "Minutes incluses par utilisateur et par mois",
        "30",
        "30",
        "60"
      ],
      [
        "Réceptionniste IA (Essentiel, Professionnel, Entreprise)",
        "dès 49 $",
        "dès 49 $",
        "dès 49 $"
      ],
      [
        "Minutes prépayées",
        "dès 25 $",
        "dès 25 $",
        "dès 25 $"
      ],
      [
        "Au-delà",
        "0,79 $ / min",
        "0,79 $ / min",
        "0,79 $ / min"
      ],
      [
        "Agents IA et flux d'appels",
        "Illimités",
        "Illimités",
        "Illimités"
      ],
      [
        "Un numéro par agent IA",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Pages de connaissances et tables de prix",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Rendez-vous : Google, Microsoft",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Textos envoyés par l'agent, au client et à vous",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Transferts vers l'équipe",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Appels sortants par l'agent (confirmations, rappels)",
        "✗",
        "✗",
        "✓"
      ],
      [
        "Français, anglais et d'autres langues",
        "✓",
        "✓",
        "✓"
      ]
    ]
  },
  {
    "name": "ÉQUIPE",
    "icon": "users",
    "rows": [
      [
        "Power dialer",
        "✗",
        "✗",
        "✓"
      ],
      [
        "Campagnes d'appels",
        "✗",
        "✗",
        "✓"
      ],
      [
        "Analytics d'équipe",
        "✗",
        "✗",
        "✓"
      ]
    ]
  },
  {
    "name": "CHATGPT ET CLAUDE",
    "icon": "chat",
    "rows": [
      [
        "Connectés à votre compte, en toute sécurité (MCP)",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Configurer votre réceptionniste",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Répondre à vos textos",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Lire les résumés, transcriptions et messages vocaux",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Chercher dans vos appels",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Créer des contacts et des tâches",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Mettre à jour vos tables de prix",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Voir les chiffres de l'équipe",
        "✓",
        "✓",
        "✓"
      ]
    ]
  },
  {
    "name": "INTÉGRATIONS",
    "icon": "plug",
    "rows": [
      [
        "Google Calendar, Microsoft 365",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Square Rendez-vous",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Clio",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Google Contacts",
        "✓",
        "✓",
        "✓"
      ],
      [
        "HubSpot",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Pipedrive",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Zoho CRM",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Slack",
        "✗",
        "✓",
        "✓"
      ],
      [
        "Zapier",
        "✓",
        "✓",
        "✓"
      ],
      [
        "API et webhooks",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Widget téléphone pour votre logiciel",
        "✓",
        "✓",
        "✓"
      ]
    ]
  },
  {
    "name": "SUPPORT",
    "icon": "headset",
    "rows": [
      [
        "Courriel",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Clavardage",
        "✓",
        "✓",
        "✓"
      ],
      [
        "Prioritaire",
        "✗",
        "✓",
        "✓"
      ],
      [
        "En français et en anglais",
        "✓",
        "✓",
        "✓"
      ]
    ]
  }
]
